module.exports = __webpack_public_path__ + "static/media/example-3.62816815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/PrinceHotel/example-3.jpg
// module id = 253
// module chunks = 0